import { useState } from 'react';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { recordScore } from '../api/quality.js';
import { ApiError } from '../api/client.js';

export function QualityScoringPage(): ReactNode {
  const { id = '' } = useParams<{ id: string }>();
  const { token } = useAuth();
  const [form, setForm] = useState({ qualityRating: '5', photoRating: '5', gpsRating: '5', areaRating: '5' });
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(): Promise<void> {
    setError(null); setMsg(null); setBusy(true);
    try {
      await recordScore(id, {
        qualityRating: Number(form.qualityRating),
        photoRating: Number(form.photoRating),
        gpsRating: Number(form.gpsRating),
        areaRating: Number(form.areaRating),
      }, token);
      setMsg('Score recorded');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Save failed');
    } finally { setBusy(false); }
  }

  return (
    <main aria-label="quality-scoring">
      <h1>Quality scoring — {id}</h1>
      {error ? <div role="alert">{error}</div> : null}
      {msg ? <div role="status">{msg}</div> : null}
      <form aria-label="score-form" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        {(['qualityRating', 'photoRating', 'gpsRating', 'areaRating'] as const).map((k) => (
          <label key={k}>{k}
            <input aria-label={k} type="number" min={1} max={5}
              value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} required />
          </label>
        ))}
        <button type="submit" disabled={busy}>Record score</button>
      </form>
    </main>
  );
}
